export enum SubPageEnum {
    summary = '',
    participants = 'participants',
    feed = 'feed',
    speakers = 'speakers',
  }